// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accept-popup[data-v-69fb2b48]{width:682px}.accept-popup[data-v-69fb2b48],.accept-popup .confirm-content[data-v-69fb2b48]{padding-top:30px}.accept-popup .pop-title[data-v-69fb2b48]{width:584px;margin:0 auto;padding:0 0 20px;font-size:14px;color:#999;text-align:center;line-height:20px;border-bottom:1px solid #f1f1f1}.accept-popup .pop-title .font-bold[data-v-69fb2b48]{color:#666;font-weight:700}.accept-popup .bind-img[data-v-69fb2b48]{display:block;margin:0 auto}", ""]);
// Exports
module.exports = exports;
